import { useContext } from 'react'
import { number, object } from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import uuid from 'uuid/v4'
import * as TemplateActions from '@admin/templates/edit-template/template.actions'
import { CvsAutoComplete } from '@components'
import { formatSelectedOptions } from '@components/select/cvs-autocomplete'
import { fieldSetContext } from '@contexts'
import { t } from '@lingui/core/macro'

export const TemplateFieldPattern = ({ fieldId, form, disabled }) => {
  const dispatch = useDispatch()
  const { byId } = useContext(fieldSetContext)
  const fieldsets = useSelector(state => state.Template.fieldsets).map(fs => {
    return { value: byId[fs.id].id, label: byId[fs.id].name }
  })
  const parameters = useSelector(state => state.Template.parameters)
  const param = parameters.find(p => p.field_id === form.id) || {
    field_id: null,
    fieldset_ids: [],
    id: `TEMP_${uuid()}`,
    name: '',
    precedence: parameters.length + 1,
    template_field: null,
    template_field_id: null,
    template_id: null,
    transform: 'none',
    url_encoding: 'dynamic',
  }

  const handleChange = val => {
    dispatch(
      TemplateActions.setParameter({
        ...param,
        template_field_id: form.template_field_id,
        field_id: fieldId,
        fieldset_ids: val,
      }),
    )
  }

  return (
    <div style={{ paddingTop: 12 }}>
      <CvsAutoComplete
        disabled={disabled}
        margin="dense"
        isMulti
        label={t`Associated field sets`}
        options={fieldsets}
        selected={formatSelectedOptions(true, param.fieldset_ids, fieldsets)}
        onSelected={val => handleChange(val || [])}
        style={{ marginTop: 0 }}
      />
    </div>
  )
}

TemplateFieldPattern.defaultProps = {
  fieldId: number.isRequired,
  form: object.isRequired,
}
